import { Injectable, Injector, Inject } from '@angular/core';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ServiceLocator } from '../helpers/service-locator';
import { PagedResult, PaginationModel } from '../models';

@Injectable()
export class BaseHttpService<T> {
  protected httpClient: HttpClient;
  protected baseUri: string = '/api';
  protected uri: string;

  constructor(route: string = '') {
    this.uri = `${this.getApiURI()}/${route}/`;
    if (ServiceLocator.injector) {
      this.httpClient = ServiceLocator.injector.get(HttpClient);
    }
  }

  getApiURI() {
    return this.baseUri;
  }

  getAll(): Observable<T[]> {

    return this.httpClient
      .get(this.uri)
      .catch(this.handleError);
  }

  getPages(pagination: PaginationModel): Observable<PagedResult<T>> {
    /*This is incomplete and shouldn't be use as is*/
    return this.httpClient
      .get(this.uri +
        `?pageNumber=${pagination.pageNumber}&pageSize=${pagination.pageSize}&orderBy=${pagination.orderBy}`)
      .catch(this.handleError);
  }


  getById(id: number): Observable<T> {

    return this.httpClient
      .get(this.uri + `${id}`)
      .catch(this.handleError);
  }

  update(id: number, entity: T): Observable<T> {
    return this.httpClient
      .put(this.uri + `${id}`, JSON.stringify(entity))
      .catch(this.handleError);
  }

  add(entity: T): Observable<T> {
    return this.httpClient
      .post(this.uri, JSON.stringify(entity))
      .catch(this.handleError);
  }

  delete(id: number) {

    return this.httpClient
      .delete(this.uri + `${id}`)
      .catch(this.handleError);
  }


  protected handleError(error: HttpErrorResponse) {
    let applicationError = error.headers.get('Application-Error');

    // either applicationError in header or model error in body
    if (applicationError) {
      return Observable.throw(applicationError);
    }

    let modelStateErrors: string = '';
    let serverError = error.error;

    if (!serverError.type) {
      for (let key in serverError) {
        if (serverError[key])
          modelStateErrors += serverError[key] + '\n';
      }
    }

    modelStateErrors = modelStateErrors = '' ? null : modelStateErrors;
    return Observable.throw(modelStateErrors || 'Server error');
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/base-http.service.ts